import randomId from 'random-id';
import { formRef } from './consts';

export default function (editor, opts = {}) {
  const domc = editor.DomComponents;

  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const formId = 'dc-survey-form-submission-' + randomId(8, '');

  domc.addType(formRef, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: ':not(form)',
          draggable: ':not(form)',
          resizable: true,
          'custom-name': 'Questionnaire Survey Answer Form',
          attributes: {
            id: formId,
          },
          traits: [...domc.getType('default').model.prototype.defaults.traits],
          script: function () {
            let collectionId = 'questionnaire_survey';
            if (typeof renderSurveySubmissionForm !== 'undefined') {
              renderSurveySubmissionForm(this, collectionId);
            }
          },
        },
      },
      {
        isComponent(el) {
          if (
            el.tagName === 'FORM' &&
            el.getAttribute &&
            el.getAttribute('data-js') === 'questionnaire-survey-answer'
          ) {
            return { type: formRef };
          }
        },
      },
    ),

    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
    }),
  });
}
